import * as React from 'react';

import styled from '@emotion/styled';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { Box, UnstyledButton, Modal, COLORS } from '@clutter/clean';

import { CircleXButton } from '@root/images/circle_x_close';
import { Picture } from '@shared/components/helpers';

const FullWindowImage = styled(Picture)`
  width: auto;
  height: auto;
  max-height: 80vh;
  max-width: 80vw;
  margin: auto;
  display: block;
`;

type ImageFragment = {
  source: string;
};

export const ImageModal: React.FC<{
  image?: ImageFragment;
  onClose(): void;
}> = ({ image, onClose }) => (
  <Modal backgroundColor={COLORS.grayBorder} isOpen={!!image} handleModalClose={onClose} overflowY="hidden">
    {image && (
      <Box position="relative">
        <Box position="absolute" left="0" top="0">
          <Box padding="16px 0 0 16px">
            <UnstyledButton onClick={onClose}>
              <CircleXButton />
            </UnstyledButton>
          </Box>
        </Box>
        <FullWindowImage source={image?.source} width={1280} height={1280} />
      </Box>
    )}
  </Modal>
);
